export default [
  // Demandes subjects list start
  {
    'tag': 'select',
    'type': 'text',
    'name': 'objet',
    "cf-conditional-category": "category_tmb_demandes",
    'cf-questions': "Choisissez l'objet de la requête ",
    "children": [
        {
            "tag": "option",
            "cf-label": "Cartes",
            "value": "subject_demande_carte",
        },
    ]
  },
  // Demandes subjects list end

  // Subject demande carte start
  {
    'tag': 'select',
    'type': 'text',
    'name': 'reason',
    "cf-conditional-category": "category_tmb_demandes",
    "cf-conditional-objet": "subject_demande_carte",
    'cf-questions': "Choisissez le motif de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Commande",
            "value": "reason_commande",
        },
        {
            "tag": "option",
            "cf-label": "Gestion",
            "value": "reason_gestion",
        },
        {
            "tag": "option",
            "cf-label": "Blocage",
            "value": "reason_blocage",
        },
        {
            "tag": "option",
            "cf-label": "TPE",
            "value": "reason_tpe",
        },
        {
            "tag": "option",
            "cf-label": "Applications",
            "value": "reason_applications",
        },
        {
            "tag": "option",
            "cf-label": "Autres",
            "value": "reason_autres",
        },
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'sub_reason',
    "cf-conditional-category": "category_tmb_demandes",
    "cf-conditional-objet": "subject_demande_carte",
    "cf-conditional-reason": "reason_blocage",
    'cf-questions': "Choisissez la raison de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Prépayé",
            "value": "sub_reason_prepaye",
        },
        {
          "tag": "option",
          "cf-label": "Débit",
          "value": "sub_reason_debit",
        },
        {
          "tag": "option",
          "cf-label": "Crédit",
          "value": "sub_reason_credit",
        },
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'sub_reason',
    "cf-conditional-category": "category_tmb_demandes",
    "cf-conditional-objet": "subject_demande_carte",
    "cf-conditional-reason": "reason_commande",
    'cf-questions': "Choisissez la raison de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Prépayé",
            "value": "sub_reason_prepaye",
        },
        {
          "tag": "option",
          "cf-label": "Débit",
          "value": "sub_reason_debit",
        },
        {
          "tag": "option",
          "cf-label": "Crédit",
          "value": "sub_reason_credit",
        },
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'reason_need',
    "cf-conditional-category": "category_tmb_demandes",
    "cf-conditional-objet": "subject_demande_carte",
    "cf-conditional-reason": "reason_commande",
    "cf-conditional-sub_reason": "sub_reason_prepaye",
    'cf-questions': "Choisissez le besoin de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Nouvelle carte",
            "value": "reason_need_nouvelle_carte",
        },
        {
          "tag": "option",
          "cf-label": "Renouvellement de carte",
          "value": "reason_need_renouvellement_de_carte",
        },
        {
          "tag": "option",
          "cf-label": "Remplacement de carte",
          "value": "reason_need_remplacement_de_carte",
        }
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'reason_need',
    "cf-conditional-category": "category_tmb_demandes",
    "cf-conditional-objet": "subject_demande_carte",
    "cf-conditional-reason": "reason_commande",
    "cf-conditional-sub_reason": "sub_reason_debit",
    'cf-questions': "Choisissez le besoin de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Nouvelle carte",
            "value": "reason_need_nouvelle_carte",
        },
        {
          "tag": "option",
          "cf-label": "Renouvellement de carte",
          "value": "reason_need_renouvellement_de_carte",
        },
        {
          "tag": "option",
          "cf-label": "Remplacement de carte",
          "value": "reason_need_remplacement_de_carte",
        }
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'reason_need',
    "cf-conditional-category": "category_tmb_demandes",
    "cf-conditional-objet": "subject_demande_carte",
    "cf-conditional-reason": "reason_commande",
    "cf-conditional-sub_reason": "sub_reason_credit",
    'cf-questions': "Choisissez le besoin de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Nouvelle carte",
            "value": "reason_need_nouvelle_carte",
        },
        {
          "tag": "option",
          "cf-label": "Renouvellement de carte",
          "value": "reason_need_renouvellement_de_carte",
        },
        {
          "tag": "option",
          "cf-label": "Remplacement de carte",
          "value": "reason_need_remplacement_de_carte",
        }
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'sub_reason',
    "cf-conditional-category": "category_tmb_demandes",
    "cf-conditional-objet": "subject_demande_carte",
    "cf-conditional-reason": "reason_gestion",
    'cf-questions': "Choisissez la raison de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Prépayé",
            "value": "sub_reason_prepaye",
        },
        {
          "tag": "option",
          "cf-label": "Débit",
          "value": "sub_reason_debit",
        },
        {
          "tag": "option",
          "cf-label": "Crédit",
          "value": "sub_reason_credit",
        },
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'reason_need',
    "cf-conditional-category": "category_tmb_demandes",
    "cf-conditional-objet": "subject_demande_carte",
    "cf-conditional-reason": "reason_gestion",
    "cf-conditional-sub_reason": "sub_reason_prepaye",
    'cf-questions': "Choisissez le besoin de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Rechargement",
            "value": "reason_need_rechargement",
        },
        {
          "tag": "option",
          "cf-label": "Transfert de solde",
          "value": "reason_need_transfert_de_solde",
        },
        {
          "tag": "option",
          "cf-label": "Demande relevé",
          "value": "reason_need_demande_releve",
        },
        {
          "tag": "option",
          "cf-label": "Changement de compte",
          "value": "reason_need_changement_de_compte",
        },
        {
          "tag": "option",
          "cf-label": "Changement N°TEL",
          "value": "reason_need_changement_n0tel",
        },
        {
          "tag": "option",
          "cf-label": "Enrôlement 3D Secure",
          "value": "reason_need_enrolement_3d_secure",
        },
        {
          "tag": "option",
          "cf-label": "Modification plafond",
          "value": "reason_need_modification_plafond",
        },
        {
          "tag": "option",
          "cf-label": "Emission Nouveau code PIN",
          "value": "reason_need_emission_nouveau_code_pin",
        }
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'reason_need',
    "cf-conditional-category": "category_tmb_demandes",
    "cf-conditional-objet": "subject_demande_carte",
    "cf-conditional-reason": "reason_gestion",
    "cf-conditional-sub_reason": "sub_reason_debit",
    'cf-questions': "Choisissez le besoin de la requête",
    "children": [
        {
          "tag": "option",
          "cf-label": "Demande relevé",
          "value": "reason_need_demande_releve",
        },
        {
          "tag": "option",
          "cf-label": "Changement de compte",
          "value": "reason_need_changement_de_compte",
        },
        {
          "tag": "option",
          "cf-label": "Changement N°TEL",
          "value": "reason_need_changement_n0tel",
        },
        {
          "tag": "option",
          "cf-label": "Enrôlement 3D Secure",
          "value": "reason_need_enrolement_3d_secure",
        },
        {
          "tag": "option",
          "cf-label": "Modification plafond",
          "value": "reason_need_modification_plafond",
        },
        {
          "tag": "option",
          "cf-label": "Emission Nouveau code PIN",
          "value": "reason_need_emission_nouveau_code_pin",
        }
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'sub_reason',
    "cf-conditional-category": "category_tmb_demandes",
    "cf-conditional-objet": "subject_demande_carte",
    "cf-conditional-reason": "reason_tpe",
    'cf-questions': "Choisissez la raison de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Rouleau",
            "value": "sub_reason_rouleau",
        },
        {
          "tag": "option",
          "cf-label": "Chargeur",
          "value": "sub_reason_chargeur",
        },
        {
          "tag": "option",
          "cf-label": "TPE additionnel",
          "value": "sub_reason_tpe_additionnel",
        },
        {
          "tag": "option",
          "cf-label": "Fonction additionnelle",
          "value": "sub_reason_fonction_additionnelle",
        },
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'sub_reason',
    "cf-conditional-category": "category_tmb_demandes",
    "cf-conditional-objet": "subject_demande_carte",
    "cf-conditional-reason": "reason_applications",
    'cf-questions': "Choisissez la raison de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Netbank",
            "value": "sub_reason_netbank",
        },
        {
          "tag": "option",
          "cf-label": "Pepele",
          "value": "sub_reason_pepele",
        }
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'reason_need',
    "cf-conditional-category": "category_tmb_demandes",
    "cf-conditional-objet": "subject_demande_carte",
    "cf-conditional-reason": "reason_applications",
    "cf-conditional-sub_reason": "sub_reason_netbank",
    'cf-questions': "Choisissez le besoin de la requête",
    "children": [
        {
            "tag": "option",
            "cf-label": "Réinitialisation",
            "value": "reason_need_reinitialisation",
        },
        {
          "tag": "option",
          "cf-label": "Crédit Access",
          "value": "reason_need_credit_access",
        },
        {
          "tag": "option",
          "cf-label": "Ajout nouvel utilisateur",
          "value": "reason_need_ajout_nouvel_utilisateur",
        },
        {
          "tag": "option",
          "cf-label": "Modification profil",
          "value": "reason_need_modification_profil",
        }
    ]
  },
  {
    'tag': 'select',
    'type': 'text',
    'name': 'reason_need',
    "cf-conditional-category": "category_tmb_demandes",
    "cf-conditional-objet": "subject_demande_carte",
    "cf-conditional-reason": "reason_applications",
    "cf-conditional-sub_reason": "sub_reason_pepele",
    'cf-questions': "Choisissez le besoin de la requête",
    "children": [
        {
          "tag": "option",
          "cf-label": "Création Accès",
          "value": "reason_need_creation_acces",
        },
        {
          "tag": "option",
          "cf-label": "Désactivation",
          "value": "reason_need_desactivation",
        },
        {
          "tag": "option",
          "cf-label": "Modification profil",
          "value": "reason_need_modification_profil",
        }
    ]
  },
  // Subject demande carte end
]
